import React, { BaseSyntheticEvent } from 'react'
import {
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonLabel,
  IonList,
  IonRow,
} from '@ionic/react'
import { calendarOutline, chevronForwardOutline, trash } from 'ionicons/icons'
import { showAlert } from '../../vitals/store/vitals.actions'
import { useDispatch, useSelector } from 'react-redux'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { IBodySurveyState } from '../bodyAssessment/bodySurvey/store/bodySurvey.types'
import { formatDateTime } from '../../../utilities/dateTime.util'
import { deleteAssessment, setSelectedAssessment } from '../store/additionalAssessments.actions'
import { getAdditionalAssessmentsSelector } from '../selectors'
import { setBodySurvey } from '../bodyAssessment/bodySurvey/store/bodySurvey.actions'
import './AdditionalAssessmentsList.component.css'

const AdditionalAssessmentsList: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const bodyAssessment = useSelector(getAdditionalAssessmentsSelector)
  const { bodySurveys } = bodyAssessment

  const handleAssessmentRowClick = (e: BaseSyntheticEvent, assessmentData: IBodySurveyState) => {
    e.preventDefault()
    history.push({ pathname: TabConstants.ADDITIONAL_ASSESSMENT_SUMMARY, state: TabConstants.ADDITIONAL_ASSESSMENTS })
    dispatch(setSelectedAssessment(assessmentData))
    dispatch(setBodySurvey(assessmentData))
  }

  const handleDelete = (seq: number) => {
    dispatch(deleteAssessment(seq))
  }

  const onDeleteClick = (assessment: IBodySurveyState) => {
    // handle assessment click
    const alertState = {
      header: t('additionalAssessments.deleteAssessment.header'),
      message: `${t('additionalAssessments.deleteAssessment.message')} Assessment ${assessment.seq}?`,
      buttons: [{ text: 'Cancel' }, { text: 'Ok', role: 'destructive', handler: () => handleDelete(assessment.seq) }],
    }
    dispatch(showAlert(alertState))
  }

  const AdditionalAssessmentListContent = () => (
    <IonList>
      {bodySurveys?.map((assessmentData: IBodySurveyState) => (
        <IonItemSliding key={assessmentData.seq}>
          <IonItem className='assessment-row-section'>
            <IonGrid onClick={(e) => handleAssessmentRowClick(e, assessmentData)}>
              <IonRow>
                <IonCol className='assessment-row-item'>
                  <IonLabel color='dark'>
                    <h2>
                      {t('additionalAssessments.Assessment')} {assessmentData.seq}
                    </h2>
                  </IonLabel>
                  <div className='assessment-date-column'>
                    <IonIcon icon={calendarOutline} className='calendar-icon' />
                    <div className='assessment-date-time'>{formatDateTime(assessmentData?.assessDt)}</div>
                    <IonIcon color='medium' icon={chevronForwardOutline} />
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonItem>
          <IonItemOptions>
            <IonItemOption color='danger' onClick={() => onDeleteClick(assessmentData)}>
              <IonIcon slot='start' icon={trash} />
              {t('common.buttons.Delete')}
            </IonItemOption>
          </IonItemOptions>
        </IonItemSliding>
      ))}
    </IonList>
  )

  return (
    <IonContent id='additional-assessment-list' color='light'>
      <AdditionalAssessmentListContent />
    </IonContent>
  )
}

export default AdditionalAssessmentsList
